var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9343",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 259",
    stroke: "#e28e09",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 12.75
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6216",
    d: "M4.5 3.5h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6217",
    d: "M13.5 13.34v-2.805",
    stroke: "#e28e09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6218",
    d: "M13.5 15.594a.188.188 0 10.188.188.186.186 0 00-.188-.187",
    stroke: "#e28e09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6219",
    d: "M15.022 6.604l5.744 10.056a1.753 1.753 0 01-1.522 2.623H7.756a1.753 1.753 0 01-1.522-2.623l5.744-10.056a1.752 1.752 0 013.044 0z",
    stroke: "#e28e09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

export default SvgWarningGroup;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Warning-group.svg
// module id = 447
// module chunks = 101